

















 import {Vue, Component, Prop, Inject } from 'vue-property-decorator';
 import SlotUserProfile from './user-profile/SlotUserProfile.vue';
 import { UserProfile } from '@api/models/UserProfile';

@Component({
     name: 'MeetingSlot',
     components: { SlotUserProfile }
 })
 export default class MeetingSlot extends Vue {
     @Prop() profile: UserProfile | undefined;
     @Prop({ default: false }) showProfile: boolean;
 }
